import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Autocomplete,
  CircularProgress,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import useAttributeListByGroup from 'api/codingAttribute/useAttributeListByGroup/useAttributeListByGroup';
import PatienceModal from 'components/shared/PatienceModal/PatienceModal';
import React, { useEffect, useMemo, useState } from 'react';

const DeleteCodeAttributeModal = ({
  open,
  handleClose,
  title,
  guid,
  groupGuid,
  deleteLoading,
  onDelete,
}) => {
  const [selectedAlternative, setSelectedAlternative] = useState(null);

  const { getAttributeListByGroup, loading, attributeListByGroup } =
    useAttributeListByGroup(groupGuid);

  useEffect(() => {
    if (open && groupGuid) {
      getAttributeListByGroup({ page: 1, count: 1000 });
      setSelectedAlternative(null);
    }
  }, [open, groupGuid]);

  const options = useMemo(() => {
    return attributeListByGroup?.filter(item => item.key !== guid);
  }, [attributeListByGroup, guid]);

  const handleDialogClose = () => {
    if (deleteLoading) return;
    setSelectedAlternative(null);
    handleClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        disableEscapeKeyDown={deleteLoading}
        sx={{ direction: 'rtl' }}
      >
        <DialogTitle>
          آیا از حذف <q>{title}</q> مطمئن هستید ؟
        </DialogTitle>

        <DialogContent sx={{ pt: 1, minWidth: 300 }}>
          <Alert
            icon={false}
            dir="rtl"
            severity="info"
            sx={{ mb: 2, direction: 'rtl' }}
          >
            این مقدار ممکن است روی کدینگ‌ها یا محصولات استفاده شده باشد. برای
            جلوگیری از خطا، قبل از حذف باید یک مقدار جایگزین انتخاب کنید تا
            موارد وابسته به آن منتقل شوند.
          </Alert>
          <Autocomplete
            options={options}
            loading={loading}
            value={selectedAlternative}
            onChange={(_, newValue) => setSelectedAlternative(newValue)}
            getOptionLabel={option => (option?.value ? `${option.value}` : '')}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            noOptionsText="موردی یافت نشد"
            disabled={deleteLoading}
            renderInput={params => (
              <TextField
                {...params}
                label="مقدار جایگزین"
                variant="standard"
                margin="dense"
                helperText="موارد استفاده‌شده از مقدار فعلی به این گزینه منتقل می‌شوند."
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={18} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </DialogContent>

        <DialogActions sx={{ gap: 1, padding: 3 }}>
          <Button
            onClick={handleDialogClose}
            variant="contained"
            disabled={deleteLoading}
          >
            انصراف
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={() => onDelete(selectedAlternative?.key)}
            loading={deleteLoading}
            disabled={!selectedAlternative}
          >
            حذف
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <PatienceModal open={deleteLoading} />
    </>
  );
};

export default DeleteCodeAttributeModal;
